export const BASE_URL = 'https://datahubupload.forvismazars.com/' //'http://localhost:3001/' // process.env.backendUrl;
export const IS_MZ_BRANDING = (process.env.VUE_APP_IS_MZ_BRANDING || '').toLowerCase() === 'true';
export const SENTRY_ENV = process.env.VUE_APP_SENTRY_ENV || "DEV"
